module.exports = __webpack_public_path__ + "images/tip-8f2ee49278.png";